export default __webpack_public_path__ + "static/media/deeleeo-reverse.ea41318a.svg";